import ProgressIndicator from './directives/ProgressIndicator';
import UnderwritingIssuesUtil from './UnderwritingIssuesUtil';

export default angular.module('edge.quoteandbind.util.app', [])
    .factory('UnderwritingIssuesUtil', UnderwritingIssuesUtil)
    .directive('gwProgressIndicator', ProgressIndicator);
